import dayjs from "dayjs";
import jquery from "jquery";

window.$ = jquery;

export const domReady = (fn) =>
  document.readyState === "interactive" || document.readyState === "complete"
    ? fn()
    : document.addEventListener("DOMContentLoaded", fn);

// TODO: DAQUI PRA BAIXO NÃO ERA PARA ESTAR AQUI E SIM EM UM ARQUIVO SEPARADO
document.addEventListener("turbo:load", () => {
  // TEM QUE ESTAR TUDO DENTRO DO TURBO:LOAD
}); // END TEM QUE ESTAR TUDO DENTRO DO TURBO:LOAD
